'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// import moment from 'moment';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _format = require('date-fns/format');

var _format2 = _interopRequireDefault(_format);

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _nitroText = require('../nitro-text');

var _nitroText2 = _interopRequireDefault(_nitroText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatThousands = function formatThousands(num) {
  var values = num.toString().split('.');
  return values[0].replace(/.(?=(?:.{3})+$)/g, '$&,') + (values.length == 2 ? '.' + values[1] : '');
};

var formatNumber = function formatNumber(data) {
  return parseFloat(data).toFixed(2).toLocaleString();
};

var toLocaleStringSupportsOptions = function toLocaleStringSupportsOptions() {
  return !!((typeof Intl === 'undefined' ? 'undefined' : _typeof(Intl)) === 'object' && Intl && typeof Intl.NumberFormat === 'function');
};

var toLocaleString = function toLocaleString(data) {
  var string = '$' + formatThousands(data);
  if (toLocaleStringSupportsOptions()) {
    string = parseFloat(data).toLocaleString('en-AU', {
      style: 'currency',
      currency: 'AUD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
  return string;
};

var NitroFormatter = function NitroFormatter(props) {
  var type = props.type,
      data = props.data,
      format = props.format;


  var convertedType = type ? type.toLowerCase() : '';

  var content = data;

  switch (convertedType) {
    case 'currency':
      content = data !== undefined ? toLocaleString(formatNumber(data)) : '';
      break;
    case 'intcurrency':
      content = data !== undefined ? toLocaleString(formatNumber(data)) : '';
      break;
    case 'shortcurrency':
      content = data !== undefined ? (0, _numeral2.default)(data).format(format || '$ 0.00 a') : '';
      break;
      break;
    case 'integer':
      content = formatThousands(parseInt(formatNumber(data), 10));
      break;
    case 'date':
      content = (0, _format2.default)(data, format || 'Do MMM YYYY');
      break;
    case 'shortinteger':
      content = (0, _numeral2.default)(data).format(format || '0 a');
      break;
    default:
      break;
  }

  return _react2.default.createElement(
    _nitroText2.default,
    props,
    content
  );
};

NitroFormatter.propTypes = {
  data: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  type: _propTypes2.default.string,
  format: _propTypes2.default.string
};

exports.default = NitroFormatter;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-formatter/NitroFormatter.js
// module id = 1286
// module chunks = 4